import React, { useState } from "react";

import Editor from "@monaco-editor/react";

export function HtmlEditor({ htmlValue, cssValue, onUpdate }) {
	const [htmlCode, setHtmlCode] = useState(htmlValue);
	const [cssCode, setCssCode] = useState(cssValue);

	return (
		<div className="grid grid-cols-2 gap-4 pb-4">
			<div className="w-[600px] p-4 border-r border-gray-200">
				{/* Code Editor */}
				<Editor
					height="70vh"
					defaultLanguage="html"
					defaultValue={htmlCode}
					formatOnPaste={true}
					formatOnType={true}
					options={{
						theme: "vs-dark",
						minimap: { enabled: false },
					}}
					onMount={(editor, monaco) => {
						editor.getAction("editor.action.formatDocument").run();
						setHtmlCode(`${htmlValue}\n`);
					}}
					onChange={(value) => {
						setHtmlCode(value);
					}}
				/>
			</div>
			<div className="w-[600px] p-4">
				{/* Code Editor */}
				<Editor
					height="70vh"
					defaultLanguage="css"
					defaultValue={cssCode}
					formatOnPaste={true}
					formatOnType={true}
					options={{
						theme: "vs-dark",
						minimap: { enabled: false },
					}}
					onMount={(editor, monaco) => {
						editor.getAction("editor.action.formatDocument").run();
					}}
					onChange={(value) => {
						setCssCode(value);
					}}
				/>
			</div>

			<div className="col-span-2 text-center">
				<button
					className="bg-blue-500 text-white px-4 py-2 rounded"
					onClick={() => {
						onUpdate({
							html: htmlCode,
							css: cssCode,
						});
					}}>
					Submit
				</button>
			</div>
		</div>
	);
}

export default function SimpleCodeEditor({ value, onUpdate }) {
	const [code, setCode] = React.useState(value);
	return (
		<div className="bg-gray-100 p-4 rounded-md border border-gray-200">
			<div className="bg-white w-[600px] h-[400px]"></div>

			<button
				className="mt-2 bg-blue-200 p-2"
				onClick={() => {
					onUpdate(code);
				}}>
				Update
			</button>
		</div>
	);
}
